import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'message', 'submit'];

  async submit(event) {
    event.preventDefault();
    this.setLoading(true);
    this.showMessage('');

    try {
      const response = await fetch(this.formTarget.action, {
        method: this.formTarget.method,
        body: new FormData(this.formTarget),
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await response.json();

      if (!response.ok) {
        this.showMessage(data.message || 'Unable to subscribe. Please try again.', true);
        return;
      }

      this.formTarget.reset();
      this.showMessage(data.message || 'Thanks for subscribing!');
    } catch (_error) {
      this.showMessage('Unable to subscribe. Please try again.', true);
    } finally {
      this.setLoading(false);
    }
  }

  showMessage(message, error = false) {
    this.messageTarget.textContent = message;
    this.messageTarget.classList.toggle('g-footer__newsletter-message--error', error);
    this.messageTarget.setAttribute('role', error ? 'alert' : 'status');
  }

  setLoading(loading) {
    this.submitTarget.disabled = loading;
  }
}
